import { useEffect } from 'react';
import { pick } from 'ramda';
import { log } from 'log';
import { useDispatch } from 'react-redux';
import { usePrevious } from 'js/hooks/usePrevious';
import { storageService } from 'js/services/storage.service';
import { useUserSelector, useAppSelector, useLiveGamesSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useLiveGamesSetContextRequest = () => {
    const dispatch = useDispatch();
    const { currencyCode, isLoggedIn, userDetails: { vipLevel: userVipLevel } } = useUserSelector(pick(['currencyCode', 'isLoggedIn', 'userDetails']));
    const { casinoName, liveGuestVipLevel } = useAppSelector(pick(['casinoName', 'liveGuestVipLevel']));
    const { socket, isSocketConnected, isContextSucceeded, isNeedToStart } = useLiveGamesSelector(pick(['socket', 'isSocketConnected', 'isContextSucceeded', 'isNeedToStart']));

    const localLiveCasinoName = storageService.local.getItem('liveCasinoName') as string;
    const guestVipLevel = liveGuestVipLevel.length && !isNaN(Number(liveGuestVipLevel)) ? Number(liveGuestVipLevel) : 1;
    const vipLevel = Number(isLoggedIn ? userVipLevel : guestVipLevel);
    const prevVipLevel = usePrevious(vipLevel);
    const prevCurrencyCode = usePrevious(currencyCode);

    useEffect(() => {
        if (vipLevel !== prevVipLevel || currencyCode !== prevCurrencyCode) {
           dispatch(actions.updateContextStatus(false));
        }
    }, [
        dispatch,
        currencyCode,
        prevCurrencyCode,
        vipLevel,
        prevVipLevel
    ]);

    useEffect(() => {
        if (!socket || !isSocketConnected || isContextSucceeded || !isNeedToStart) {
            return;
        }

        const request = {
            setContextRequest : {
                currency: currencyCode,
                vipLevel: Number(vipLevel),
                casino: localLiveCasinoName || casinoName
            }
        };

        log('log', '[LIVE | Portal] sending setContextRequest', request);

        socket.send(request);
    }, [
        casinoName,
        currencyCode,
        isContextSucceeded,
        isNeedToStart,
        isSocketConnected,
        localLiveCasinoName,
        socket,
        vipLevel
    ]);
};
